import React, { useEffect, useState } from 'react'
import BottomSheet from '.'
import InputField from '../InputField'
import RadioButton from '../RadioButton/RadioButton'
import Button from '../ButtonNew'

const AddressBottomSheet = ({ address, show, onClose, onProceed }) => {
  console.log('AddressBottomSheet', address)
  const [formFields, setFormFields] = useState({
    pincode: address?.pincode || '',
    houseNumber: address?.houseNumber || '',
    street: address?.street || '',
    addressType: address?.addressType || '',
  })

  useEffect(() => {
    setFormFields({
      pincode: address?.pincode || '',
      houseNumber: address?.houseNumber || address?.formatted_address,
      street: address?.street || '',
      addressType: address?.addressType || '',
    })
  }, [address])
  const handleChange = (key, value) => {
    setFormFields({ ...formFields, [key]: value })
  }

  const handleProceed = () => {
    onProceed(formFields)
  }

  return (
    <BottomSheet show={show} onClose={onClose} title="Add Address">
      <div className="p-4 flex flex-col gap-4">
        <InputField
          label="Pincode*"
          value={formFields.pincode}
          onChange={(e) => handleChange('pincode', e.target.value)}
        />
        <InputField
          label="House Number and Builing*"
          value={formFields.houseNumber}
          onChange={(e) => handleChange('houseNumber', e.target.value)}
        />
        <InputField
          label="Street Name*"
          value={formFields.street}
          onChange={(e) => handleChange('street', e.target.value)}
        />

        <div className="flex flex-col gap-2">
          <label className="text-text-primary text-[#101828] text-sm font-medium">
            Address Type*
          </label>
          <div className="flex items-center gap-2">
            <RadioButton
              label="Home"
              isSelected={formFields.addressType === 'home'}
              onClick={() => handleChange('addressType', 'home')}
            />
            <RadioButton
              label="Work"
              isSelected={formFields.addressType === 'work'}
              onClick={() => handleChange('addressType', 'work')}
            />
            <RadioButton
              label="Other"
              isSelected={formFields.addressType === 'other'}
              onClick={() => handleChange('addressType', 'other')}
            />
          </div>
        </div>
      </div>

      <div className="flex gap-4 border-t border-gray-200 p-4">
        <Button variant="outlined" fullWidth onClick={onClose}>
          Back
        </Button>
        <Button
          fullWidth
          onClick={handleProceed}
          disabled={
            !formFields.pincode ||
            !formFields.houseNumber ||
            !formFields.street ||
            !formFields.addressType
          }
        >
          Proceed
        </Button>
      </div>
    </BottomSheet>
  )
}

export default AddressBottomSheet
